{
  "text": {
    "type": "string",
    "maxLength": 4000
  },
  "number": {
    "type": "number"
  },
  "booleanValue": {
    "type": "boolean"
  },
  "a11y": {
    "tabindex": {
      "type": "number",
      "minimum": -1,
      "maximum": 0,
      "description": "The value used for tabIndex attribute"
    },
    "ariaLevel": {
      "type": "number",
      "minimum": 1,
      "maximum": 6,
      "description": "The value used for aria-level"
    },
    "ariaExpanded": {
      "type": "boolean",
      "description": "The value used for aria-expanded"
    },
    "ariaDisabled": {
      "type": "boolean",
      "description": "The value used for aria-disabled"
    },
    "ariaAtomic": {
      "type": "boolean",
      "description": "The value used for aria-atomic"
    },
    "ariaHidden": {
      "type": "boolean",
      "description": "The value used for aria-hidden"
    },
    "ariaBusy": {
      "type": "boolean",
      "description": "The value used for aria-busy"
    },
    "multiline": {
      "type": "boolean",
      "description": "Indicates if should add Multiline instructions to aria-label"
    },
    "autocomplete": {
      "type": "boolean",
      "description": "Indicates if should add Autocomplete instructions to aria-label"
    },
    "ariaPressed": {
      "type": "string",
      "enum": [
        "false",
        "true",
        "mixed"
      ],
      "description": "The value used for aria-pressed"
    },
    "ariaHaspopup": {
      "type": "string",
      "enum": [
        "true",
        "false",
        "dialog",
        "menu"
      ],
      "description": "The value used for aria-haspopup"
    },
    "ariaRelevant": {
      "type": "string",
      "enum": [
        "additions",
        "additions text",
        "all",
        "removals",
        "text"
      ],
      "description": "The value used for aria-relevant"
    },
    "role": {
      "type": "string",
      "enum": [
        "region",
        "group",
        "tablist",
        "tab",
        "tabpanel",
        "alert",
        "status",
        "list",
        "listitem",
        "menubar",
        "presentation",
        "button",
        "link",
        "none",
        "radiogroup",
        "heading",
        "nav"
      ],
      "description": "The value used for role attribute"
    },
    "ariaLive": {
      "type": "string",
      "enum": [
        "polite",
        "assertive"
      ],
      "description": "The value used for aria-live"
    },
    "ariaCurrent": {
      "type": "string",
      "enum": [
        "page",
        "step",
        "location",
        "date",
        "time",
        "true",
        "false"
      ],
      "description": "The value used for aria-current"
    },
    "ariaLabel": {
      "type": "string",
      "description": "The text used for aria-label"
    },
    "ariaRoledescription": {
      "type": "string",
      "description": "The text used for aria-roledescription"
    },
    "ariaDescribedby": {
      "type": "string",
      "description": "The value used for aria-describedby"
    },
    "ariaLabelledby": {
      "type": "string",
      "description": "The value used for aria-labelleddby"
    },
    "ariaErrorMessage": {
      "type": "string",
      "description": "The text used for aria-errormessage"
    },
    "ariaOwns": {
      "type": "string",
      "description": "The text used for aria-owns"
    },
    "ariaControls": {
      "type": "string",
      "description": "The text used for aria-controls"
    },
    "tag": {
      "type": "string",
      "description": "The HTML tag to use for the element"
    },
    "ariaMultiline": {
      "type": "boolean",
      "description": "The value used for aria-multiline"
    },
    "ariaInvalid": {
      "type": "string",
      "enum": [
        "grammar",
        "spelling",
        "false",
        "true"
      ],
      "description": "The value used for aria-invalid"
    }
  },
  "link": {
    "externalLink": {
      "$ref": "ExternalLink"
    },
    "emailLink": {
      "$ref": "EmailLink"
    },
    "anchorLink": {
      "$ref": "AnchorLink"
    },
    "edgeAnchorLink": {
      "$ref": "AnchorLink"
    },
    "phoneLink": {
      "$ref": "PhoneLink"
    },
    "pageLink": {
      "anyOf": [
        {
          "$ref": "PageLink"
        },
        {
          "$ref": "DynamicPageLink"
        },
        {
          "$ref": "TPAPageLink"
        }
      ]
    },
    "popupLink": {
      "$ref": "PageLink"
    },
    "whatsAppLink": {
      "$ref": "WhatsAppLink"
    },
    "documentLink": {
      "$ref": "DocumentLink"
    },
    "addressLink": {
      "$ref": "AddressLink"
    },
    "loginToWixLink": {
      "type": "object",
      "properties": {
        "postLoginUrl": {
          "anyOf": [
            {
              "$ref": "PageLink"
            },
            {
              "$ref": "AnchorLink"
            },
            {
              "$ref": "ExternalLink"
            }
          ]
        },
        "postSignupUrl": {
          "anyOf": [
            {
              "$ref": "PageLink"
            },
            {
              "$ref": "AnchorLink"
            },
            {
              "$ref": "ExternalLink"
            }
          ]
        },
        "dialog": {
          "type": "string",
          "enum": [
            "createUser",
            "login",
            "showLogin"
          ],
          "default": "login"
        }
      }
    }
  },
  "image": {
    "$ref": "Builder.Image"
  },
  "video": {
    "$ref": "Builder.Video"
  },
  "vectorArt": {
    "$ref": "Builder.VectorArt"
  },
  "audio": {},
  "localDate": {
    "type": "string",
    "format": "date"
  },
  "localTime": {
    "type": "string",
    "format": "time"
  },
  "localDateTime": {
    "type": "string",
    "format": "date-time"
  },
  "webUrl": {
    "type": "string",
    "format": "uri",
    "pattern": "^https?://"
  },
  "email": {
    "type": "string",
    "pattern": "^(?:[\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:[\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z0-9](?:[\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z0-9-]*[\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z0-9])?\\.)+(?:(?:[0-9]+[\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z][\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z0-9]*)|(?:[\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z][\\u00A1-\\uD7FF\\uE000-\\uFFFF-a-zA-Z0-9]{1,}))$"
  },
  "phone": {
    "type": "string",
    "pattern": "^[\\d\\s\\+\\-\\(\\)\\.]+$"
  },
  "hostname": {
    "type": "string",
    "format": "hostname"
  },
  "regex": {
    "type": "string",
    "format": "regex"
  },
  "guid": {
    "type": "string",
    "pattern": "^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0]{8}-[0]{4}-[0]{4}-[0]{4}-[0]{12})$"
  },
  "richText": {
    "$ref": "Builder.RichText"
  },
  "direction": {
    "type": "string",
    "enum": [
      "ltr",
      "rtl",
      "auto"
    ]
  },
  "menuItems": {
    "type": "string"
  },
  "time": {}
}
